import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { cn } from '@/lib/utils'

/**
 * Dashboard stat: micro-label over a mono tabular value, optional hint line.
 * `emphasis` adds the manifest rail (an allowed rail site); `to` renders the
 * whole tile as a link with the standard hover border/bg shift.
 */
export function StatTile({
  label,
  value,
  hint,
  emphasis = false,
  to,
  className,
}: {
  label: string
  value: ReactNode
  hint?: ReactNode
  emphasis?: boolean
  to?: string
  className?: string
}) {
  const classes = cn(
    'block rounded-md border border-rule bg-card p-4',
    emphasis && 'manifest-rail',
    to &&
      'no-underline transition-colors duration-[180ms] ease-editorial hover:border-mute hover:bg-cream',
    className,
  )
  const content = (
    <>
      <span className="micro-label block">{label}</span>
      <span className="mt-1 block font-mono text-xl font-semibold tabular-nums text-ink">
        {value}
      </span>
      {hint ? <span className="mt-1 block text-xs text-mute">{hint}</span> : null}
    </>
  )
  return to ? (
    <Link to={to} className={classes}>
      {content}
    </Link>
  ) : (
    <div className={classes}>{content}</div>
  )
}
